

import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MwcDestroyService } from 'mwc/core/services';
import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-option-item',
  template: `
    <div class="mwc-select-item-option-content">
      <ng-template [ngIf]="customContent" [ngIfElse]="noCustomContent">
        <label *ngIf="showState; else defaultCustom" [ngModel]="selected" mwc-checkbox mwcSize="small">
          <ng-template [ngTemplateOutlet]="template"></ng-template>
        </label>
        <ng-template #defaultCustom><ng-template [ngTemplateOutlet]="template"></ng-template></ng-template>
      </ng-template>
      <ng-template #noCustomContent><label *ngIf="showState; else default" [ngModel]="selected"  mwc-checkbox mwcSize="small">{{ label }}</label></ng-template>
      <ng-template #default>{{ label }}</ng-template>
    </div>
    <!-- <div *ngIf="showState && selected" class="mwc-select-item-option-state" style="user-select: none" unselectable="on">
      <span mwc-icon mwcType="check" class="mwc-select-selected-icon" *ngIf="!icon; else icon"></span>
    </div> -->
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'mwc-select-item mwc-select-item-option',
    '[attr.title]': 'label',
    '[class.mwc-select-item-option-grouped]': 'grouped',
    '[class.mwc-select-item-option-selected]': 'selected && !disabled',
    '[class.mwc-select-item-option-disabled]': 'disabled',
    '[class.mwc-select-item-option-active]': 'activated && !disabled'
  },
  providers: [MwcDestroyService]
})
export class MwcOptionItemComponent implements OnChanges, OnInit {
  selected = false;
  activated = false;
  @Input() grouped = false;
  @Input() customContent = false;
  @Input() template: TemplateRef<MwcSafeAny> | null = null;
  @Input() disabled = false;
  @Input() showState = false;
  @Input() label: string | number | null = null;
  @Input() value: MwcSafeAny | null = null;
  @Input() activatedValue: MwcSafeAny | null = null;
  @Input() listOfSelectedValue: MwcSafeAny[] = [];
  @Input() icon: TemplateRef<MwcSafeAny> | null = null;
  @Input() compareWith!: (o1: MwcSafeAny, o2: MwcSafeAny) => boolean;
  @Output() readonly itemClick = new EventEmitter<MwcSafeAny>();
  @Output() readonly itemHover = new EventEmitter<MwcSafeAny>();

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private ngZone: NgZone,
    private destroy$: MwcDestroyService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { value, activatedValue, listOfSelectedValue } = changes;
    if (value || listOfSelectedValue) {
      this.selected = this.listOfSelectedValue.some(v => this.compareWith(v, this.value));
    }
    if (value || activatedValue) {
      this.activated = this.compareWith(this.activatedValue, this.value);
    }
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.elementRef.nativeElement, 'click')
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (!this.disabled) {
            this.ngZone.run(() => this.itemClick.emit(this.value));
          }
        });

      fromEvent(this.elementRef.nativeElement, 'mouseenter')
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (!this.disabled) {
            this.ngZone.run(() => this.itemHover.emit(this.value));
          }
        });
    });
  }
}
